import JsonLd from '@/components/JsonLd'
import { organizationSchema, webSiteSchema } from '@/lib/jsonLdSchemas'
import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'
import Hero from '@/components/sections/Hero'
import Services from '@/components/sections/Services'
import Approach from '@/components/sections/Approach'
import About from '@/components/sections/About'
import Work from '@/components/sections/Work'
import Clients from '@/components/sections/Clients'
import Contact from '@/components/sections/Contact'
import Newsletter from '@/components/sections/Newsletter'

export default function Home() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground selection:bg-accent selection:text-white">
      <JsonLd data={organizationSchema} />
      <JsonLd data={webSiteSchema} />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Approach />
        <Work />
        <Clients />
        <Contact />
        <Newsletter />
      </main>
      <Footer />
    </div>
  )
}
